import { gql } from 'apollo-angular';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: any;
  /** Decimal custom scalar type */
  Decimal: any;
  JSON: any;
  Upload: any;
};

export type Account = {
  __typename?: 'Account';
  account: Scalars['String'];
  active: Scalars['Boolean'];
  blocked_apps: Array<Scalars['String']>;
  created_at: CustomDate;
  detail?: Maybe<AccountDetail>;
  feature?: Maybe<Feature>;
  group?: Maybe<AccountGroup>;
  id: Scalars['Int'];
  layout?: Maybe<AccountLayout>;
  meta_configs?: Maybe<Scalars['JSON']>;
  meta_labels?: Maybe<Scalars['JSON']>;
  password_manager: Scalars['String'];
  skip_omie_status: Scalars['Boolean'];
  sync_error?: Maybe<Scalars['String']>;
  updated_at: CustomDate;
  warning?: Maybe<Scalars['String']>;
};

export type AccountDetail = {
  __typename?: 'AccountDetail';
  address?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  cnpj: Scalars['String'];
  company_name: Scalars['String'];
  country?: Maybe<Scalars['String']>;
  cpf_rep?: Maybe<Scalars['String']>;
  district?: Maybe<Scalars['String']>;
  email_adm?: Maybe<Scalars['String']>;
  email_rep?: Maybe<Scalars['String']>;
  ie?: Maybe<Scalars['String']>;
  name_rep?: Maybe<Scalars['String']>;
  phone_number1?: Maybe<Scalars['String']>;
  phone_number2?: Maybe<Scalars['String']>;
  razao_social?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  zip_code?: Maybe<Scalars['String']>;
};

export type AccountEdgesResponse = {
  __typename?: 'AccountEdgesResponse';
  edges: Array<Account>;
  pagination?: Maybe<Pagination>;
};

export type AccountGroup = {
  __typename?: 'AccountGroup';
  account: Scalars['String'];
  active: Scalars['Boolean'];
  feature?: Maybe<Feature>;
  id: Scalars['Int'];
};

export type AccountInfo = {
  __typename?: 'AccountInfo';
  account: Scalars['String'];
  active: Scalars['Boolean'];
  blocked_apps: Array<Scalars['String']>;
  created: CustomDate;
  detail?: Maybe<AccountDetail>;
  feature?: Maybe<Feature>;
  group?: Maybe<AccountGroup>;
  id: Scalars['Int'];
  modified: CustomDate;
  skip_omie_status: Scalars['Boolean'];
  warning?: Maybe<Scalars['String']>;
};

export type AccountLayout = {
  __typename?: 'AccountLayout';
  background_ref?: Maybe<Scalars['String']>;
  background_src?: Maybe<Scalars['String']>;
  layout_ref?: Maybe<Scalars['String']>;
  logo_ref?: Maybe<Scalars['String']>;
  logo_src?: Maybe<Scalars['String']>;
};

export type AccountResponse = {
  __typename?: 'AccountResponse';
  data: Account;
  message: Scalars['String'];
};

export enum AlertIconEnum {
  Error = 'Error',
  Info = 'Info',
  Success = 'Success',
  Warning = 'Warning'
}

export type ConditionAccountInput = {
  active?: InputMaybe<Scalars['Boolean']>;
};

export type ConditionDateInput = {
  eq?: InputMaybe<Scalars['Date']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
};

export type ConditionFloatInput = {
  eq?: InputMaybe<Scalars['Float']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
};

export type ConditionIntInput = {
  eq?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  ne?: InputMaybe<Scalars['Int']>;
};

export type ConditionUserInput = {
  account?: InputMaybe<Scalars['Int']>;
  role?: InputMaybe<RoleEnum>;
};

export type CopyTablesInput = {
  account: Scalars['Int'];
  ids: Array<Scalars['Int']>;
  labels?: InputMaybe<Array<Scalars['String']>>;
};

export type CreateAccountDetailInput = {
  address?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  cnpj: Scalars['String'];
  company_name: Scalars['String'];
  country?: InputMaybe<Scalars['String']>;
  cpf_rep?: InputMaybe<Scalars['String']>;
  district?: InputMaybe<Scalars['String']>;
  email_adm?: InputMaybe<Scalars['String']>;
  email_rep?: InputMaybe<Scalars['String']>;
  ie?: InputMaybe<Scalars['String']>;
  name_rep?: InputMaybe<Scalars['String']>;
  phone_number1?: InputMaybe<Scalars['String']>;
  phone_number2?: InputMaybe<Scalars['String']>;
  razao_social?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  zip_code?: InputMaybe<Scalars['String']>;
};

export type CreateAccountInput = {
  account: Scalars['String'];
  detail: CreateAccountDetailInput;
  feature_id: Scalars['Int'];
  group_id?: InputMaybe<Scalars['Int']>;
  meta_configs?: InputMaybe<Scalars['JSON']>;
  meta_labels?: InputMaybe<Scalars['JSON']>;
  password_manager?: InputMaybe<Scalars['String']>;
};

export type CreateNoteInput = {
  account: Scalars['Int'];
  content: Scalars['String'];
  type: NoteTypeEnum;
};

export type CreateTablesInput = {
  account: Scalars['Int'];
  labels?: InputMaybe<Array<Scalars['String']>>;
  origin?: InputMaybe<Scalars['String']>;
  tables: Array<TableUpload>;
};

export type CreateUserInput = {
  account?: InputMaybe<Scalars['Int']>;
  login: Scalars['String'];
  password: Scalars['String'];
  role: RoleEnum;
};

export type CreateUserKcInput = {
  accounts: Array<Scalars['Int']>;
  email: Scalars['String'];
  groups: Array<GroupKcEnum>;
  name: Scalars['String'];
  password: Scalars['String'];
};

export type CustomDate = {
  __typename?: 'CustomDate';
  /** Formats a string to the ISO8601 standard. */
  iso?: Maybe<Scalars['String']>;
  /** String matches the RFC 2822 Date time format */
  string?: Maybe<Scalars['String']>;
  /** Integer value representing the number of milliseconds since the Unix Epoch (Jan 1 1970 12AM UTC). */
  timestamp?: Maybe<Scalars['Float']>;
  /** This function returns the real offset from UTC, not the reverse offset */
  timezone?: Maybe<Scalars['String']>;
  /**
   * If you know the format of an input string, you can use that to parse a date.
   * Read more: [momentjs format date](https://momentjs.com/docs/#/parsing/string-format)
   */
  transform?: Maybe<Scalars['String']>;
  /** Unix timestamp (seconds since the Unix Epoch) */
  unix?: Maybe<Scalars['Float']>;
  /** UTC time instead of local time */
  utc?: Maybe<Scalars['String']>;
};


export type CustomDateTimezoneArgs = {
  offset: Scalars['String'];
};


export type CustomDateTransformArgs = {
  format: Scalars['String'];
};

export type CustomNumber = {
  __typename?: 'CustomNumber';
  currency?: Maybe<Scalars['String']>;
  fixed?: Maybe<Scalars['String']>;
  float?: Maybe<Scalars['Float']>;
  format?: Maybe<Scalars['String']>;
  int?: Maybe<Scalars['Int']>;
  string?: Maybe<Scalars['String']>;
};


export type CustomNumberCurrencyArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  digits?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
};


export type CustomNumberFixedArgs = {
  digits: Scalars['Int'];
};


export type CustomNumberFormatArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  digits?: InputMaybe<Scalars['Int']>;
};

export type Feature = {
  __typename?: 'Feature';
  created_at: CustomDate;
  data: Array<FeatureData>;
  id: Scalars['Int'];
  name: Scalars['String'];
  updated_at: CustomDate;
};

export type FeatureData = {
  __typename?: 'FeatureData';
  feature: Scalars['String'];
  quote?: Maybe<Scalars['Int']>;
};

export enum FilterScopeEnum {
  OnlyActive = 'OnlyActive',
  OnlyTrashed = 'OnlyTrashed',
  WithTrashed = 'WithTrashed'
}

export enum GroupKcEnum {
  Franqueado = 'Franqueado',
  PromoAdmin = 'PromoAdmin'
}

export type InfoApi = {
  __typename?: 'InfoAPI';
  commit: Scalars['String'];
  date?: Maybe<Scalars['String']>;
  environment: Scalars['String'];
  image: Scalars['String'];
  name: Scalars['String'];
  shortCommit: Scalars['String'];
  version: Scalars['String'];
};

export type Layout = {
  __typename?: 'Layout';
  background_is_custom: Scalars['Boolean'];
  background_src?: Maybe<Scalars['String']>;
  logo_is_custom: Scalars['Boolean'];
  logo_src?: Maybe<Scalars['String']>;
  template_ref?: Maybe<Scalars['String']>;
};

export type LayoutInput = {
  background?: InputMaybe<Scalars['Upload']>;
  logo?: InputMaybe<Scalars['Upload']>;
  template_ref?: InputMaybe<Scalars['String']>;
};

export type LayoutResponse = {
  __typename?: 'LayoutResponse';
  data: Layout;
  message: Scalars['String'];
};

export type LoadCepExternalApiResponse = {
  __typename?: 'LoadCepExternalApiResponse';
  cep?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  district?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
};

export type LoadCnpjExternalApiResponse = {
  __typename?: 'LoadCnpjExternalApiResponse';
  account_detail?: Maybe<AccountDetail>;
  warning?: Maybe<Scalars['String']>;
};

export type LoginInput = {
  origin?: InputMaybe<LoginOriginEnum>;
  password: Scalars['String'];
  username: Scalars['String'];
};

export type LoginKcInput = {
  password: Scalars['String'];
  secret: Scalars['String'];
  username: Scalars['String'];
};

export enum LoginOriginEnum {
  Default = 'Default',
  Ivision = 'IVISION',
  Lensbook = 'LENSBOOK',
  PanelV2 = 'PanelV2'
}

export type LoginResponse = {
  __typename?: 'LoginResponse';
  /** JWT access API */
  access_token: Scalars['String'];
  /**
   * Mesmo tokenAPI concatenando Bearer
   * Forma pratica de copiar token para colar no header do playground
   */
  authorization: Scalars['String'];
  /** Tempo para expirar o token */
  expires_in: Scalars['Float'];
};

export type Mutation = {
  __typename?: 'Mutation';
  copyTables: TableResponse;
  createAccount: AccountResponse;
  createNote: NoteResponse;
  createTables: TableResponse;
  createUser: UserResponse;
  login: LoginResponse;
  ping: SimpleResponse;
  removeLayout: SimpleResponse;
  removeNote: NoteResponse;
  removeTables: TableResponse;
  removeUser: UserResponse;
  setActiveAccount: AccountResponse;
  setBlockAccount: AccountResponse;
  updateAccount: AccountResponse;
  updateUser: UserResponse;
  upsertLayout: LayoutResponse;
};


export type MutationCopyTablesArgs = {
  input: CopyTablesInput;
};


export type MutationCreateAccountArgs = {
  input: CreateAccountInput;
};


export type MutationCreateNoteArgs = {
  input: CreateNoteInput;
};


export type MutationCreateTablesArgs = {
  input: CreateTablesInput;
};


export type MutationCreateUserArgs = {
  input: CreateUserInput;
};


export type MutationLoginArgs = {
  input: LoginInput;
};


export type MutationPingArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type MutationRemoveLayoutArgs = {
  ref: Scalars['String'];
};


export type MutationRemoveNoteArgs = {
  id: Scalars['ID'];
};


export type MutationRemoveTablesArgs = {
  ids: Array<Scalars['Int']>;
};


export type MutationRemoveUserArgs = {
  id: Scalars['Int'];
};


export type MutationSetActiveAccountArgs = {
  active: Scalars['Boolean'];
  id: Scalars['Int'];
  message: Scalars['String'];
};


export type MutationSetBlockAccountArgs = {
  apps?: InputMaybe<Array<Scalars['String']>>;
  block: Scalars['Boolean'];
  id: Scalars['Int'];
  message: Scalars['String'];
};


export type MutationUpdateAccountArgs = {
  id: Scalars['Int'];
  input: UpdateAccountInput;
};


export type MutationUpdateUserArgs = {
  id: Scalars['Int'];
  input: UpdateUserInput;
};


export type MutationUpsertLayoutArgs = {
  input: LayoutInput;
};

export type Note = {
  __typename?: 'Note';
  content: Scalars['String'];
  created_at: CustomDate;
  id: Scalars['ID'];
  type: NoteTypeEnum;
  user?: Maybe<UserInfo>;
};

export type NoteResponse = {
  __typename?: 'NoteResponse';
  data: Note;
  message: Scalars['String'];
};

export enum NoteTypeEnum {
  Block = 'Block',
  Comment = 'Comment',
  Danger = 'Danger',
  Fixed = 'Fixed',
  Info = 'Info',
  System = 'System',
  Warning = 'Warning'
}

export enum OmieApplicationCodeEnum {
  Ivision = 'IVISION',
  Lensbook = 'LENSBOOK',
  Rental = 'RENTAL'
}

export type Pagination = {
  __typename?: 'Pagination';
  last_page: Scalars['Int'];
  page: Scalars['Int'];
  per_page: Scalars['Int'];
  total: Scalars['Int'];
};

export enum PermissionEnum {
  AccountKcUserRead = 'AccountKcUserRead',
  AccountKcUserWrite = 'AccountKcUserWrite',
  AccountRead = 'AccountRead',
  AccountWrite = 'AccountWrite',
  AclRead = 'AclRead',
  FeatureRead = 'FeatureRead',
  LayoutRead = 'LayoutRead',
  LayoutWrite = 'LayoutWrite',
  NoteRead = 'NoteRead',
  NoteWrite = 'NoteWrite',
  TablePriceRead = 'TablePriceRead',
  TablePriceWrite = 'TablePriceWrite',
  UserRead = 'UserRead',
  UserSecrets = 'UserSecrets',
  UserWrite = 'UserWrite'
}

export type PermissionGroup = {
  __typename?: 'PermissionGroup';
  group: Scalars['String'];
  permissions: Array<PermissionEnum>;
};

export type PresignedFileInput = {
  mime: Scalars['String'];
  name: Scalars['String'];
};

export type Query = {
  __typename?: 'Query';
  account?: Maybe<Account>;
  accountGroups: Array<AccountGroup>;
  accounts: AccountEdgesResponse;
  clearCache: Scalars['String'];
  features: Array<Feature>;
  infoApi: InfoApi;
  layout?: Maybe<Layout>;
  layouts: Array<Maybe<Layout>>;
  loadCepExternalApi?: Maybe<LoadCepExternalApiResponse>;
  loadCnpjExternalApi?: Maybe<LoadCnpjExternalApiResponse>;
  myAccount: Account;
  myIp: Scalars['String'];
  myUser: User;
  notesByAccount: Array<Note>;
  permissions: Array<PermissionGroup>;
  roles: Array<RoleEnum>;
  search: Array<SearchItem>;
  secretsByUser: Array<UserSecret>;
  tables: Array<Maybe<Table>>;
  tablesLabelGroups: Array<Maybe<Scalars['String']>>;
  user: User;
  users: UserEdgesResponse;
};


export type QueryAccountArgs = {
  id: Scalars['Int'];
};


export type QueryAccountsArgs = {
  params?: InputMaybe<SearchAccountsInput>;
};


export type QueryLayoutArgs = {
  ref: Scalars['String'];
};


export type QueryLoadCepExternalApiArgs = {
  cep: Scalars['String'];
};


export type QueryLoadCnpjExternalApiArgs = {
  cnpj: Scalars['String'];
};


export type QueryNotesByAccountArgs = {
  account: Scalars['Int'];
};


export type QuerySearchArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  term: Scalars['String'];
  type?: InputMaybe<SearchItemTypeEnum>;
};


export type QuerySecretsByUserArgs = {
  id: Scalars['Int'];
};


export type QueryTablesArgs = {
  params: SearchTablesInput;
};


export type QueryUserArgs = {
  id: Scalars['Int'];
};


export type QueryUsersArgs = {
  params?: InputMaybe<SearchUsersInput>;
};

export enum ReportGroupDateEnum {
  DayOfMonth = 'DayOfMonth',
  Month = 'Month',
  Week = 'Week',
  Year = 'Year'
}

export type RequestAppInfo = {
  __typename?: 'RequestAppInfo';
  ip?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  platform?: Maybe<Scalars['String']>;
  serial?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['String']>;
};

export enum RoleEnum {
  Admin = 'Admin',
  Franqueado = 'Franqueado',
  Seller = 'Seller',
  User = 'User'
}

export type SearchAccountsInput = {
  and?: InputMaybe<ConditionAccountInput>;
  page?: InputMaybe<Scalars['Int']>;
  per_page?: InputMaybe<Scalars['Int']>;
  q?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<SortAccountInput>;
};

export type SearchItem = {
  __typename?: 'SearchItem';
  account_id?: Maybe<Scalars['Int']>;
  account_name?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  type: SearchItemTypeEnum;
};

export enum SearchItemTypeEnum {
  Account = 'Account',
  GroupAccount = 'GroupAccount',
  User = 'User'
}

export type SearchTablesInput = {
  account?: InputMaybe<Scalars['Int']>;
  account_find_labels?: InputMaybe<Scalars['Boolean']>;
  labels?: InputMaybe<Array<Scalars['String']>>;
};

export type SearchUsersInput = {
  and?: InputMaybe<ConditionUserInput>;
  page?: InputMaybe<Scalars['Int']>;
  per_page?: InputMaybe<Scalars['Int']>;
  q?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<SortUserInput>;
};

export type SimpleResponse = {
  __typename?: 'SimpleResponse';
  message: Scalars['String'];
};

export type SortAccountInput = {
  account?: InputMaybe<SortOrderEnum>;
  created_at?: InputMaybe<SortOrderEnum>;
};

export enum SortOrderEnum {
  Asc = 'Asc',
  Desc = 'Desc'
}

export type SortUserInput = {
  created?: InputMaybe<SortOrderEnum>;
  login?: InputMaybe<SortOrderEnum>;
};

export type Subscription = {
  __typename?: 'Subscription';
  pong: SimpleResponse;
};


export type SubscriptionPongArgs = {
  minLength?: InputMaybe<Scalars['Int']>;
};

export type Table = {
  __typename?: 'Table';
  copy_ref?: Maybe<Scalars['Int']>;
  created_at: CustomDate;
  description: Scalars['String'];
  filename: Scalars['String'];
  id: Scalars['Int'];
  is_owner: Scalars['Boolean'];
  labels?: Maybe<Array<Scalars['String']>>;
  link: Scalars['String'];
  origin?: Maybe<Scalars['String']>;
  original_filename: Scalars['String'];
  path?: Maybe<Scalars['String']>;
  product_type: TableProdTypeEnum;
  table_id: Scalars['Int'];
  table_type: Scalars['String'];
  timestamp: Scalars['Float'];
  updated_at: CustomDate;
};

export enum TableProdTypeEnum {
  Bifocal = 'Bifocal',
  Multifocal = 'Multifocal',
  Ocupacional = 'Ocupacional',
  Simples = 'Simples'
}

export type TableResponse = {
  __typename?: 'TableResponse';
  data: Array<Table>;
  message: Scalars['String'];
};

export type TableUpload = {
  description: Scalars['String'];
  file: Scalars['Upload'];
  type: TableProdTypeEnum;
};

export type TestResult = {
  __typename?: 'TestResult';
  code: Scalars['String'];
  description: Scalars['String'];
  icon: AlertIconEnum;
  title: Scalars['String'];
};

export type TestResultResponse = {
  __typename?: 'TestResultResponse';
  message: Scalars['String'];
  result: Array<TestResult>;
};

export type UpdateAccountDetailInput = {
  address?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  cnpj?: InputMaybe<Scalars['String']>;
  company_name?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  cpf_rep?: InputMaybe<Scalars['String']>;
  district?: InputMaybe<Scalars['String']>;
  email_adm?: InputMaybe<Scalars['String']>;
  email_rep?: InputMaybe<Scalars['String']>;
  ie?: InputMaybe<Scalars['String']>;
  name_rep?: InputMaybe<Scalars['String']>;
  phone_number1?: InputMaybe<Scalars['String']>;
  phone_number2?: InputMaybe<Scalars['String']>;
  razao_social?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  zip_code?: InputMaybe<Scalars['String']>;
};

export type UpdateAccountInput = {
  account?: InputMaybe<Scalars['String']>;
  detail?: InputMaybe<UpdateAccountDetailInput>;
  feature_id?: InputMaybe<Scalars['Int']>;
  group_id?: InputMaybe<Scalars['Int']>;
  meta_configs?: InputMaybe<Scalars['JSON']>;
  meta_labels?: InputMaybe<Scalars['JSON']>;
  password_manager?: InputMaybe<Scalars['String']>;
};

export type UpdateUserInput = {
  account?: InputMaybe<Scalars['Int']>;
  login?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<RoleEnum>;
};

export type UploadSignedFields = {
  __typename?: 'UploadSignedFields';
  key: Scalars['String'];
  value: Scalars['String'];
};

export type UploadSignedObject = {
  __typename?: 'UploadSignedObject';
  fields: Array<UploadSignedFields>;
  fullUrl: Scalars['String'];
  key: Scalars['String'];
  url: Scalars['String'];
};

export type User = {
  __typename?: 'User';
  account?: Maybe<AccountInfo>;
  created_at: CustomDate;
  deleted_at?: Maybe<CustomDate>;
  id: Scalars['Int'];
  last_login?: Maybe<CustomDate>;
  last_login_attempt?: Maybe<CustomDate>;
  last_login_error?: Maybe<Scalars['String']>;
  login: Scalars['String'];
  permissions: Array<PermissionEnum>;
  role: RoleEnum;
  updated_at: CustomDate;
};

export type UserEdgesResponse = {
  __typename?: 'UserEdgesResponse';
  edges: Array<User>;
  pagination?: Maybe<Pagination>;
};

export type UserInfo = {
  __typename?: 'UserInfo';
  id: Scalars['Int'];
  login: Scalars['String'];
};

export type UserInfoKc = {
  __typename?: 'UserInfoKC';
  accounts: Array<AccountInfo>;
  email: Scalars['String'];
  groups: Array<GroupKcEnum>;
  name: Scalars['String'];
  sub: Scalars['String'];
  username: Scalars['String'];
};

export type UserKcResponse = {
  __typename?: 'UserKCResponse';
  data: UserInfoKc;
  message: Scalars['String'];
};

export type UserResponse = {
  __typename?: 'UserResponse';
  data: User;
  message: Scalars['String'];
};

export type UserSecret = {
  __typename?: 'UserSecret';
  login: Scalars['String'];
  name: Scalars['String'];
  password: Scalars['String'];
};
